import type React from 'react';

import { Translate } from '@change-corgi/core-react/i18n';

import { ActionButtonWrapper } from './ActionButtonWrapper';
import { CustomButton } from './CustomButton';
import { useMobileShareModal, usePreloadMobileShareModal } from './MobileShareModal';

type Props = {
	sticky: boolean;
	visible: boolean;
	hideSocialProof?: boolean;
};

export const MobileShareButtonContainer: React.FC<Props> = ({ sticky, visible, hideSocialProof = false }) => {
	const openModal = useMobileShareModal();

	usePreloadMobileShareModal();

	return (
		<ActionButtonWrapper visible={visible} sticky={sticky} hideSocialProof={hideSocialProof}>
			<CustomButton inverted onClick={openModal} data-qa="mobile-share-button">
				<Translate value="fe.components.petition_share.action" />
			</CustomButton>
		</ActionButtonWrapper>
	);
};
